import { Snippet, SnippetConfigurationColumn } from '../services/dataModels';

export const getConfigurationsForAllRows = (snippet: Snippet) => {
  if (snippet.type === 'Matrix') {
    return [...snippet.configuration.matrixCells]
      .sort((a, b) =>
        a.rowNumber === b.rowNumber ? a.colNumber - b.colNumber : a.rowNumber - b.rowNumber,
      )
      .map((v, i) => ({
        ...snippet.configuration.columns[v.colNumber - 1],
        id: i + 1,
        controlType: v.controlType,
        controlValues: v.controlValues,
      }));
  }

  return snippet.configuration.columns;
};

export const getSomeRowConfiguration = (
  configurations: SnippetConfigurationColumn[],
  rowIndex: number,
  colCount: number,
) =>
  configurations.length === colCount
    ? configurations
    : configurations.slice(rowIndex * colCount, colCount * (rowIndex + 1));
